const TOKEN_KEY = 'gl.token';
const LAST_LOCAL_KEY = 'gl.lastLocal';

function safeStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function getStoredToken(): string | null {
  return safeStorage()?.getItem(TOKEN_KEY) ?? null;
}

export function setStoredToken(token: string): void {
  safeStorage()?.setItem(TOKEN_KEY, token);
}

export function clearStoredToken(): void {
  safeStorage()?.removeItem(TOKEN_KEY);
}

export function getLastLocalId(): string | null {
  return safeStorage()?.getItem(LAST_LOCAL_KEY) ?? null;
}

export function setLastLocalId(localId: string): void {
  safeStorage()?.setItem(LAST_LOCAL_KEY, localId);
}
